import React, { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import M from "materialize-css";

import FormularioEditar from "../../../Components/FormularioEditar";
import SideNav from "../../../Components/SideNav";
import Loader from "../../../Components/Loader";

import CursosHelper from "../../../Helpers/Cursos";
import EtiquetasHelper from "../../../Helpers/Etiquetas";
import ProfesoresCursosHelpers from "../../../Helpers/ProfesoresCursos";
import useStorage from "../../../Hooks/useStorage";

import "./Curso.css";

import icon1 from "../../../Images/administrador/iconos/1.png";
import icon63 from "../../../Images/Icon/63.png";
// formato
import img_curso from "../../../Images/iconos_administrador/curso.svg";
import img_diplomado from "../../../Images/iconos_administrador/diplomado.svg";
import img_taller from "../../../Images/iconos_administrador/taller.svg";
// modalidad
import img_classroom from "../../../Images/iconos_administrador/classroom.svg";
import img_hibrido from "../../../Images/iconos_administrador/hibrido.svg";
import img_video from "../../../Images/iconos_administrador/video.svg";
import img_presencial from "../../../Images/iconos_administrador/presencial.svg";
// otros
import img_nivel from "../../../Images/iconos_administrador/nivel.svg";
import img_warning from "../../../Images/iconos_administrador/warning.svg";
import img_requieres from "../../../Images/iconos_administrador/requieres.svg";
import img_whats from "../../../Images/iconos_administrador/whats.svg";

import Etiqueta from "../../../Components/Cursos/Etiqueta";
import OfertaRelampago from "./OfertaRelampago";

import { useAuth } from "../../../Context/Context";

const Curso = () => {
  const { ofertaRelampago } = useAuth();

  const [curso, setCurso] = useState({});
  const [etiquetas, setEtiquetas] = useState([]);
  const [profesoresCursos, setProfesoresCursos] = useState([]);
  const [flag, setFlag] = useState(false);
  const [flagActualizar, setFlagActualizar] = useState(false);
  const [carrusel, setCarrusel] = useState(0);
  const [youtubePregunta, setYoutubePregunta] = useState(false);

  const formato_img = ["", img_taller, img_curso, img_diplomado];
  const modalidad_img = [
    "",
    img_presencial,
    img_hibrido,
    img_video,
    img_classroom,
  ];

  const modailida = [
    "",
    "Presencial",
    "Híbrido",
    "Videorreunión",
    "Google Classroom",
  ];
  const formato = ["", "Taller", "Curso", "Diplomado"];
  const nivel = [
    "",
    "Iniciación",
    "Requiere conocimientos previos",
    "- vacio -",
    " - vacio -",
  ];
  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  // variables formulario
  const [instance, setInstance] = useState({});
  const [flagFechas, setFlagFechas] = useState(true);
  const [descripcionCurso, setDescripcionCurso] = useState("");
  const [descripcionExterna, setDescripcionExterna] = useState("");
  const [descripcionInterna, setDescripcionInterna] = useState("");
  const [contenido, setContenido] = useState("");
  const [fechas, setFechas] = useState([]);
  // fin - variables formulario

  // uso de hooks para agregar imagen a google storage
  const [consulta, setConsulta] = useState("");
  let [response] = useStorage(consulta);

  // imagenes a editar, si el curso no se a editado debe contener un total de 9 imagenes
  const [imagenesEliminar, setImagenesEliminar] = useState([]);
  const [imagenesEliminarCarrusel, setImagenesEliminarCarrusel] = useState([]);

  // variables para el storage
  const [files, setFiles] = useState({});
  const [filesCarrusel, setFilesCarrusel] = useState([]);

  // funcion de cambio formulario
  const [opcionVista, setOpcionVista] = useState(false);

  useEffect(() => {
    if (!response) {
      obtenerCurso();
      window.addEventListener("scroll", () => {
        let elemento = document.getElementById("curso_fixme");
        let imagen_estatica = document.getElementById("imagen_estatica");
        let imagen_estatica_bottom =
          imagen_estatica.getBoundingClientRect().bottom;
        if (imagen_estatica_bottom <= 0) {
          if (elemento.className === "curso_fijo") {
            elemento.className = "curso_fixme";
          }
        } else {
          if (elemento.className === "curso_fixme") {
            elemento.className = "curso_fijo";
          }
        }
      });
    } else {
      if (response.action === "eliminarRecursivo") {
        // despues de que se eliminaron las imagenes al eliminar un curso
        eliminarCurso();
      } else if (response.action === "eliminarRecursivoActualizar") {
        // despues de que se eliminaron las imagenes al actualizar curso
        // se van a agregar las imagenes nuevas
        subirArchivo();
      } else if (response.action === "agregarRecursivoCursos") {
        // despues de que se agregaran las imagenes nuevas al editar curso
        // se van a actualizar la imformacion a mongo
        actualizarCursoForm(response.data);
      } else {
        // error
      }
    }
  }, [response]);

  const actualizarFechaInicio = (date, index, fechas) => {
    let copiaFechas = [...fechas];
    copiaFechas[index].fecha_inicio = date;

    setFechas(copiaFechas);
  };

  const actualizarFechaFin = (date, index, fechas) => {
    let copiaFechas = [...fechas];
    copiaFechas[index].fecha_fin = date;
    setFechas(copiaFechas);
  };

  const obtenerCurso = async () => {
    let param = window.location.pathname.split("/")[2];

    let res = await CursosHelper.obtenerUnCursoNombre(param);

    if (!res.success || !res.data || res.data.length === 0) {
      res = await CursosHelper.obtenerUnCursoSlug(param);
    }

    if (res.success && res.data && res.data.length > 0) {
      setCurso(res.data[0]);
      setDescripcionCurso(res.data[0].descripcion_curso);
      setDescripcionExterna(res.data[0].descripcion_externa);
      setDescripcionInterna(res.data[0].descripcion_interna);
      setContenido(res.data[0].contenido);
      await obtenerEtiquetas(res.data[0].etiquetas);
      setFechas(res.data[0].fechas);
      obtenerProfesoresCursos();
    } else {
      Swal.fire(
        "Error!",
        "No se encontró el curso, codigo: " + res.code,
        "error"
      );
    }
  };

  const obtenerProfesoresCursos = async () => {
    let res = await ProfesoresCursosHelpers.obtenerProfesores();
    if (res.success) {
      setProfesoresCursos(res.data);
      setFlag(true);
      setFlagActualizar(true);
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener los profesores, codigo: " + res.code,
        "error"
      );
    }

    let select = document.querySelectorAll("select");
    let instance = M.FormSelect.init(select);
    setInstance(instance);
  };

  const obtenerEtiquetas = async (ids) => {
    let res = [];

    res = await EtiquetasHelper.obtenerEtiquetas();

    if (res.success) {
      setEtiquetas(res.data);
      var elems = document.querySelectorAll(".collapsible");
      M.Collapsible.init(elems);
    } else {
      Swal.fire(
        "Error!",
        "No se lograron obtener las etiquetas, codigo: " + res.code,
        "error"
      );
    }

    return true;
  };

  function createMarkup(materias) {
    return { __html: materias };
  }

  // insecion de editor de texto
  const actualizarCurso = () => {
    let ventana = document.getElementById("ventana_editable_editar");
    ventana.className = "ventana_editable col s3";
    let vista = document.getElementById("vistas_generales");
    vista.className = "col s9";
    let cerrar = document.getElementById("invisible_cerrar");
    cerrar.className = "invisible_cerrar_activado";

    // despues de pintar el formulario
    let ckedittor_contenedor = document.getElementById(
      "descripcion_externa_nuevo"
    );
    ReactDOM.render(
      <CKEditor
        editor={ClassicEditor}
        config={{
          toolbar: [
            "heading",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "undo",
            "redo",
          ],
        }}
        data={descripcionExterna}
        onChange={(event, editor) => {
          function removeTags(str) {
            if (str === null || str === "") return false;
            else str = str.toString();

            return str.replace(/(<([^>]+)>)/gi, "");
          }

          const data = editor.getData();

          let res = removeTags(data);

          if (res.split("").length > 100) {
            Swal.fire(
              "Límite alcanzado!",
              "El límite de caracteres es de 100",
              "error"
            );
          } else {
            setDescripcionExterna(data);
          }
        }}
      />,
      ckedittor_contenedor
    );

    let ckedittor_contenedor_2 = document.getElementById(
      "seccion_interna_nuevo"
    );
    ReactDOM.render(
      <Fragment>
        <div>
          <p>Descripcion Curso</p>
          <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: [
                "heading",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "undo",
                "redo",
              ],
            }}
            data={descripcionCurso}
            onChange={(event, editor) => {
              const data = editor.getData();
              setDescripcionCurso(data);
            }}
          />
        </div>
        <div>
          <p>Descripcion Interna</p>
          <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: [
                "heading",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "undo",
                "redo",
              ],
            }}
            data={descripcionInterna}
            onChange={(event, editor) => {
              const data = editor.getData();
              setDescripcionInterna(data);
            }}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <p>Contenido del curso</p>
          <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: [
                "heading",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "undo",
                "redo",
              ],
            }}
            data={contenido}
            onChange={(event, editor) => {
              const data = editor.getData();
              setContenido(data);
            }}
          />
        </div>
      </Fragment>,
      ckedittor_contenedor_2
    );

    actualizarPicker(fechas);
  };

  // pickers solo de datos del curso, no contiene oferta relampago
  const actualizarPicker = (fechas) => {
    // let fechas = res.fechas
    setTimeout(() => {
      let elems = document.querySelectorAll(".datepicker");

      fechas.map((fecha, index) => {
        M.Datepicker.init(elems[index * 2], {
          onSelect: (data) => {
            actualizarFechaInicio(data, index, fechas);
          },
          setDefaultDate: true,
          defaultDate: new Date(fecha.fecha_inicio),
        });
        M.Datepicker.init(elems[index * 2 + 1], {
          onSelect: (data) => {
            actualizarFechaFin(data, index, fechas);
          },
          setDefaultDate: true,
          defaultDate: new Date(fecha.fecha_fin),
        });
      });

      let elems_select = document.querySelectorAll("select");
      let instance = M.FormSelect.init(elems_select);
      setInstance(instance);
    }, 100);
  };

  // funciones del formulario
  const leerDato = (e) => {
    setCurso({
      ...curso,
      [e.target.name]: e.target.value,
    });
  };

  const actualizarFoto = (e) => {
    // almacenamiento de las imagenes a eliminar
    console.log("foto normal");
    let copiaImagenesEliminar = [...imagenesEliminar];
    console.log(copiaImagenesEliminar);
    let copiaCurso = { ...curso };
    let fotoAnterior = copiaCurso[[e.target.name]];
    console.log({ copiaCurso });
    copiaImagenesEliminar.push(fotoAnterior);
    console.log({ fotoAnterior, copiaImagenesEliminar });
    console.log("----------------------------");

    // almacenamiento de imagenes para subir al storage
    setFiles({
      ...files,
      [e.target.name]: e.target.files[0],
    });

    let fileReader = new FileReader();

    fileReader.addEventListener("load", (evt) => {
      setCurso({
        ...curso,
        [e.target.name]: fileReader.result,
      });
      setImagenesEliminar(copiaImagenesEliminar);
    });
    fileReader.readAsDataURL(e.target.files[0]);
  };

  const leerOpciones = (e) => {
    e.preventDefault();
    let value;
    if (e.target.name === "area") {
      value = instance[0].getSelectedValues();
    } else if (e.target.name === "modalidad") {
      value = instance[1].getSelectedValues();
    } else if (e.target.name === "formato") {
      value = instance[2].getSelectedValues();
    } else if (e.target.name === "dias") {
      value = instance[3].getSelectedValues();
    } else if (e.target.name === "etiquetas") {
      value = instance[6].getSelectedValues();
    } else {
      value = instance[6].getSelectedValues();
    }
    setCurso({
      ...curso,
      [e.target.name]: value,
    });
  };

  const agregarFecha = (e) => {
    e.preventDefault();
    let copiaFechas = [...curso.fechas];
    copiaFechas.push({
      dias: "",
      horario: "",
      fecha: "",
      sesiones: "",
      duracion: "",
      tutor: "",
    });
    setCurso({
      ...curso,
      fechas: copiaFechas,
    });

    actualizarPicker(copiaFechas);
  };

  const eliminarFecha = (e, index) => {
    e.preventDefault();
    if (fechas.length <= 1) {
      return Swal.fire(
        "No se puede ejecutar esta acción",
        "No puedes eliminar todas las fechas",
        "error"
      );
    }

    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea eliminar la fechaa?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setFlagFechas(false);
        let copiaFechas = [...curso.fechas];
        let copiaFechasExtras = [...fechas];

        copiaFechas.splice(index, 1);
        copiaFechasExtras.splice(index, 1);

        setCurso({
          ...curso,
          fechas: copiaFechas,
        });
        setFechas(copiaFechasExtras);

        setTimeout(() => {
          Swal.fire(
            "Eliminación exitosa",
            "La fecha se elimino correctamente",
            "succes"
          );
          setFlagFechas(true);
          actualizarPicker(copiaFechas);
        }, 500);
      } else if (result.isDenied) {
        Swal.fire("Eliminación cancelada", "La fecha quedo intacta", "succes");
      }
    });
  };

  const leerFecha = (e, index) => {
    e.preventDefault();
    let copiaFechas = [...curso.fechas];

    copiaFechas[index][e.target.name] = e.target.value;

    setCurso({
      ...curso,
      fechas: copiaFechas,
    });
  };

  const leerPago = (e) => {
    let copiaPago = { ...curso.data_pago };
    copiaPago[e.target.name] = e.target.value;

    setCurso({
      ...curso,
      data_pago: copiaPago,
    });
  };

  const actualizarCarrusel = (e) => {
    if (e.target.files.length === 6) {
      // almacenamiento de las imagenes a eliminar
      console.log("foto carrusel");
      let copiaCurso = { ...curso };
      let fotosAnteriores = copiaCurso[[e.target.name]];
      console.log({ fotosAnteriores });
      setImagenesEliminarCarrusel(fotosAnteriores);
      console.log("----------------------------");

      // almacenamiento de imagenes a subir al storage
      setFilesCarrusel(e.target.files);

      let imagenes = [];

      for (let index = 0; index < 6; index++) {
        const imagen = e.target.files[index];
        let fileReader = new FileReader();
        fileReader.addEventListener("load", (evt) => {
          imagenes.push(fileReader.result);

          if (index === 5) {
            setCurso({
              ...curso,
              [e.target.name]: imagenes,
            });
          }
        });
        fileReader.readAsDataURL(imagen);
      }
    } else {
      e.target.value = "";
      Swal.fire("Error!", "Debes seleccionar 6 imagenes", "error");
    }
  };

  const verificarImagenesEliminar = (e) => {
    e.preventDefault();
    let allImagenesEliminar = imagenesEliminar.concat(imagenesEliminarCarrusel);

    console.log({ allImagenesEliminar, imagenesEliminarCarrusel });
    let body = {
      ...curso,
      descripcion_curso: descripcionCurso,
      descripcion_externa: descripcionExterna,
      descripcion_interna: descripcionInterna,
      contenido,
      fechas,
    };

    if (
      body.contenido === undefined ||
      body.descripcion_externa === undefined ||
      body.descripcion_interna === undefined ||
      body.nivel === undefined ||
      body.imagen_externa === undefined ||
      body.imagen_interna === undefined ||
      body.imagen_externa === "" ||
      body.imagen_interna === "" ||
      body.fechas.length === 0 ||
      // body.etiquetas === undefined ||
      body.data_pago.costo_total === undefined
    ) {
      Swal.fire("Error!", "Faltan datos por llenar", "error");
      return false;
    }

    if (!curso.storage && allImagenesEliminar.length !== 9) {
      Swal.fire(
        "Error!",
        "Es necesario actualizar todas las imagenes",
        "error"
      );
      return false;
    }

    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea actualizar el curso?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        if (allImagenesEliminar.length === 0) {
          actualizarCursoForm();
        } else {
          eliminarArchivosRecursivoEditar(allImagenesEliminar);
        }
      } else if (result.isDenied) {
        Swal.fire(
          "Actualización cancelada",
          "El campo quedo intacto",
          "succes"
        );
      }
    });
  };

  // paso final al actualizar, se actualiza en mongoose
  const actualizarCursoForm = (data = {}) => {
    setFlagActualizar(false);

    let body = {
      ...curso,
      ...data,
      descripcion_curso: descripcionCurso,
      descripcion_externa: descripcionExterna,
      descripcion_interna: descripcionInterna,
      contenido,
      fechas,
    };

    console.log({ ofertaRelampago });

    if (ofertaRelampago.oferta_relampago) {
      body.estado_relampago = {};
      body.fecha_relampago = {};

      // descuentos
      body.estado_relampago.descuento =
        ofertaRelampago.data_pago.descuento_relampago;

      body.estado_relampago.fecha_fin = new Date(
        new Date(ofertaRelampago.pickerInfoFechaFin.setHours(17)).setMinutes(59)
      );
      body.estado_relampago.fecha_inicio = ofertaRelampago.pickerInfoFechaFin;

      // fechas
      body.fecha_relampago.fecha_inicio =
        ofertaRelampago.pickerOfertaFechaInicio;
      body.fecha_relampago.fecha_fin = ofertaRelampago.pickerOfertaFechaFin;
      body.fecha_relampago.dias = ofertaRelampago.fecha_relampago.dias;
      body.fecha_relampago.horario = ofertaRelampago.fecha_relampago.horario;
      body.fecha_relampago.sesiones = ofertaRelampago.fecha_relampago.sesiones;
      body.fecha_relampago.duracion = ofertaRelampago.fecha_relampago.duracion;
      body.fecha_relampago.tutor = ofertaRelampago.fecha_relampago.tutor;
    }

    console.log({ body, data });

    CursosHelper.editarCurso(body, curso._id);
  };

  const eliminarCurso = () => {
    CursosHelper.eliminarCurso(curso._id);
  };
  // fin de las funciones del formulario

  const leerYoutube = (e) => {
    let value = e.target.value.split("=");
    setCurso({
      ...curso,
      [e.target.name]: "https://www.youtube.com/embed/" + value[1],
    });
  };

  const obtenerProfesor = (id) => {
    let res = profesoresCursos.filter((profesor) => profesor._id === id);

    if (res.length > 0) {
      return res[0];
    } else {
      return {
        nombre: "- informacion invalida -",
        certificado: "- informacion invalida -",
        imagen: "- informacion invalida -",
      };
    }
  };

  // consultas a storage de google
  const eliminarArchivosRecursivo = (e) => {
    e.preventDefault();

    let urls = [...curso.carrusel_imagenes];
    urls.push(curso.imagen_externa);
    urls.push(curso.imagen_indvidual);
    urls.push(curso.imagen_interna);

    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea eliminar el campo?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setConsulta({
          consulta: "eliminarRecursivo",
          url: "/cursos-diplomados",
          urlsDelete: urls,
        });
      } else if (result.isDenied) {
        Swal.fire("Eliminación cancelada", "El campo quedo intacto", "succes");
      }
    });
  };

  const eliminarArchivosRecursivoEditar = (imagenes) => {
    let urls = [...imagenes];
    console.log({ urls });

    setConsulta({
      consulta: "eliminarRecursivoActualizar",
      url: "/cursos-diplomados",
      urlsDelete: urls,
    });
  };

  const subirArchivo = () => {
    console.log("subir los archivos");

    let cursoData = {
      ...curso,
      fechas: fechas,
    };

    console.log({ cursoData, files, filesCarrusel });

    setConsulta({
      consulta: "agregarRecursivoCursos",
      name: cursoData.nombre,
      folder: "cursos/",
      filesJSON: { files, filesCarrusel },
      url: "/cursos-diplomados",
    });
  };

  // funcion cambio vista
  const cambioVista = (vista) => {
    setOpcionVista(vista);

    setTimeout(() => {
      if (!vista) {
        // despues de cambiar de vista
        let ckedittor_contenedor = document.getElementById(
          "descripcion_externa_nuevo"
        );
        ReactDOM.render(
          <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: [
                "heading",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "undo",
                "redo",
              ],
            }}
            data={descripcionExterna}
            onChange={(event, editor) => {
              function removeTags(str) {
                if (str === null || str === "") return false;
                else str = str.toString();

                return str.replace(/(<([^>]+)>)/gi, "");
              }

              const data = editor.getData();

              let res = removeTags(data);

              if (res.split("").length > 100) {
                Swal.fire(
                  "Límite alcanzado!",
                  "El límite de caracteres es de 100",
                  "error"
                );
              } else {
                setDescripcionExterna(data);
              }
            }}
          />,
          ckedittor_contenedor
        );

        let ckedittor_contenedor_2 = document.getElementById(
          "seccion_interna_nuevo"
        );
        ReactDOM.render(
          <Fragment>
            <div>
              <p>Descripcion Curso</p>
              <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "heading",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "undo",
                    "redo",
                  ],
                }}
                data={descripcionCurso}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescripcionCurso(data);
                }}
              />
            </div>
            <div>
              <p>Descripcion Interna</p>
              <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "heading",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "undo",
                    "redo",
                  ],
                }}
                data={descripcionInterna}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescripcionInterna(data);
                }}
              />
            </div>
            <div style={{ marginTop: "20px" }}>
              <p>Contenido del curso</p>
              <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "heading",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "undo",
                    "redo",
                  ],
                }}
                data={contenido}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setContenido(data);
                }}
              />
            </div>
          </Fragment>,
          ckedittor_contenedor_2
        );

        actualizarPicker(fechas);
      }
    }, 10);
  };

  return (
    <Fragment>
      <SideNav />
      <div className="row">
        <FormularioEditar>
          <div className="row center">
            <div className="col s12">
              <ul>
                <li className="col s6">
                  <button
                    className="boton_cursos"
                    onClick={() => {
                      cambioVista(false);
                    }}
                  >
                    Datos
                  </button>
                </li>
                <li className="col s6">
                  <button
                    className="boton_cursos"
                    onClick={() => {
                      cambioVista(true);
                    }}
                  >
                    Oferta
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <p className="titulo_1_admin">Editar curso</p>
          {!flag ? (
            <Loader />
          ) : (
            <form onSubmit={verificarImagenesEliminar}>
              {!opcionVista ? (
                <Fragment>
                  <p>Ficha exterior</p>
                  {/* aqui hay imagen */}
                  <img
                    alt="imagen subida"
                    style={{ width: "100%" }}
                    src={curso.imagen_externa}
                  ></img>
                  <div className="file-field input-field">
                    <div className="btn">
                      <span>File</span>
                      <input
                        name="imagen_externa"
                        onChange={actualizarFoto}
                        type="file"
                      />
                    </div>
                    <div className="file-path-wrapper">
                      <input
                        name="imagen_externa"
                        className="file-path validate"
                        type="text"
                        placeholder="Upload one or more files"
                      />
                    </div>
                  </div>

                  <div className="input-field">
                    <select
                      name="area"
                      onChange={leerOpciones}
                      multiple
                      required
                    >
                      {curso.area.includes("1") ? (
                        <option value="1" selected>
                          Animación, Animé y Cómic
                        </option>
                      ) : (
                        <option value="1">Animación, Animé y Cómic</option>
                      )}
                      {curso.area.includes("2") ? (
                        <option value="2" selected>
                          Audio y Voz
                        </option>
                      ) : (
                        <option value="2">Audio y Voz</option>
                      )}
                      {curso.area.includes("3") ? (
                        <option value="3" selected>
                          Cine y Video
                        </option>
                      ) : (
                        <option value="3">Cine y Video</option>
                      )}
                      {curso.area.includes("4") ? (
                        <option value="4" selected>
                          Artes plásticas
                        </option>
                      ) : (
                        <option value="4">Artes plásticas</option>
                      )}
                      {curso.area.includes("5") ? (
                        <option value="5" selected>
                          Diseño
                        </option>
                      ) : (
                        <option value="5">Diseño</option>
                      )}
                      {curso.area.includes("6") ? (
                        <option value="6" selected>
                          Emprende
                        </option>
                      ) : (
                        <option value="6">Emprende</option>
                      )}
                      {curso.area.includes("7") ? (
                        <option value="7" selected>
                          Escritura
                        </option>
                      ) : (
                        <option value="7">Escritura</option>
                      )}
                      {curso.area.includes("8") ? (
                        <option value="8" selected>
                          Fotografía
                        </option>
                      ) : (
                        <option value="8">Fotografía</option>
                      )}
                      {curso.area.includes("9") ? (
                        <option value="9" selected>
                          Teoría del arte
                        </option>
                      ) : (
                        <option value="9">Teoría del arte</option>
                      )}
                      {curso.area.includes("10") ? (
                        <option value="10" selected>
                          Marketing y la Web
                        </option>
                      ) : (
                        <option value="10">Marketing y la Web</option>
                      )}
                      {curso.area.includes("11") ? (
                        <option value="11" selected>
                          Multimedia y Videojuegos
                        </option>
                      ) : (
                        <option value="11">Multimedia y Videojuegos</option>
                      )}
                      {curso.area.includes("12") ? (
                        <option value="12" selected>
                          Suite de Adobe
                        </option>
                      ) : (
                        <option value="12">Suite de Adobe</option>
                      )}
                      {curso.area.includes("13") ? (
                        <option value="13" selected>
                          Artes escénicas
                        </option>
                      ) : (
                        <option value="13">Artes escénicas</option>
                      )}
                    </select>
                    <label>Area</label>
                  </div>
                  <div className="input-field">
                    <select
                      placeholder="Modalidad"
                      name="modalidad"
                      onChange={leerOpciones}
                      multiple
                      required
                    >
                      {curso.modalidad.includes("1") ? (
                        <option value="1" selected>
                          Presencial
                        </option>
                      ) : (
                        <option value="1">Presencial</option>
                      )}
                      {curso.modalidad.includes("2") ? (
                        <option value="2" selected>
                          Híbrido
                        </option>
                      ) : (
                        <option value="2">Híbrido</option>
                      )}
                      {curso.modalidad.includes("3") ? (
                        <option value="3" selected>
                          Videorreunión
                        </option>
                      ) : (
                        <option value="3">Videorreunión</option>
                      )}
                      {curso.modalidad.includes("4") ? (
                        <option value="4" selected>
                          Google Classroom
                        </option>
                      ) : (
                        <option value="4">Google Classroom</option>
                      )}
                    </select>
                    <label>Modalidad</label>
                  </div>
                  <div className="input-field">
                    <select
                      placeholder="Formato"
                      name="formato"
                      onChange={leerOpciones}
                      multiple
                      required
                    >
                      {curso.formato.includes("1") ? (
                        <option value="1" selected>
                          Taller
                        </option>
                      ) : (
                        <option value="1">Taller</option>
                      )}
                      {curso.formato.includes("2") ? (
                        <option value="2" selected>
                          Curso
                        </option>
                      ) : (
                        <option value="2">Curso</option>
                      )}
                      {curso.formato.includes("3") ? (
                        <option value="3" selected>
                          Diplomado
                        </option>
                      ) : (
                        <option value="3">Diplomado</option>
                      )}
                    </select>
                    <label>Formato</label>
                  </div>
                  <div className="input-field">
                    <select
                      placeholder="Días"
                      name="dias"
                      onChange={leerOpciones}
                      multiple
                      required
                    >
                      {curso.dias.includes("0") ? (
                        <option value="0" selected>
                          Lunes
                        </option>
                      ) : (
                        <option value="0">Lunes</option>
                      )}
                      {curso.dias.includes("1") ? (
                        <option value="1" selected>
                          Martes
                        </option>
                      ) : (
                        <option value="1">Martes</option>
                      )}
                      {curso.dias.includes("2") ? (
                        <option value="2" selected>
                          Miércoles
                        </option>
                      ) : (
                        <option value="2">Miércoles</option>
                      )}
                      {curso.dias.includes("3") ? (
                        <option value="3" selected>
                          Jueves
                        </option>
                      ) : (
                        <option value="3">Jueves</option>
                      )}
                      {curso.dias.includes("4") ? (
                        <option value="4" selected>
                          Viernes
                        </option>
                      ) : (
                        <option value="4">Viernes</option>
                      )}
                      {curso.dias.includes("5") ? (
                        <option value="5" selected>
                          Sábado
                        </option>
                      ) : (
                        <option value="5">Sábado</option>
                      )}
                      {curso.dias.includes("6") ? (
                        <option value="6" selected>
                          On demand
                        </option>
                      ) : (
                        <option value="6">On demand</option>
                      )}
                    </select>
                    <label>Días</label>
                  </div>

                  <div className="input-field">
                    <select name="nivel" onChange={leerDato} required>
                      {curso.nivel === "1" ? (
                        <option value="1" selected>
                          Iniciación
                        </option>
                      ) : (
                        <option value="1">Iniciación</option>
                      )}
                      {curso.nivel === "2" ? (
                        <option value="2" selected>
                          Requiere conocimientos previos
                        </option>
                      ) : (
                        <option value="2">
                          Requiere conocimientos previos
                        </option>
                      )}
                      {curso.nivel === "3" && (
                        <option value="3" selected>
                          - vacio -
                        </option>
                      )}
                      {curso.nivel === "4" && (
                        <option value="4" selected>
                          - vacio -
                        </option>
                      )}
                    </select>
                    <label>Nivel del Curso</label>
                  </div>
                  <div className="input-field">
                    <input
                      onChange={leerDato}
                      defaultValue={curso.nombre}
                      id="nombre"
                      name="nombre"
                      type="text"
                      className="validate"
                      required
                    />
                    <label className="active" for="nombre">
                      Nombre del curso
                    </label>
                  </div>
                  <div className="input-field">
                    <input
                      onChange={leerDato}
                      value={curso.slug || ""}
                      id="slug"
                      name="slug"
                      type="text"
                      className="validate"
                    />
                    <label className="active" htmlFor="slug">
                      Slug (URL amigable)
                    </label>
                  </div>

                  <p>Descripcion Externa</p>
                  <div id="descripcion_externa_nuevo"></div>

                  {/* aqui hay imagen */}
                  <p>Ficha interna</p>
                  <p>Imagen Principal</p>
                  <img
                    alt="imagen subida"
                    style={{ width: "320px" }}
                    src={curso.imagen_interna}
                  ></img>
                  <div className="file-field input-field">
                    <div className="btn">
                      <span>File</span>
                      <input
                        name="imagen_interna"
                        onChange={actualizarFoto}
                        type="file"
                      />
                    </div>
                    <div className="file-path-wrapper">
                      <input
                        name="imagen_interna"
                        className="file-path validate"
                        type="text"
                        placeholder="Upload one or more files"
                      />
                    </div>
                  </div>

                  <div id="seccion_interna_nuevo"></div>

                  <div className="input-field">
                    <input
                      onChange={leerDato}
                      defaultValue={curso.requisitos}
                      id="requisitos"
                      name="requisitos"
                      type="text"
                      className="validate"
                      required
                    />
                    <label className="active" for="requisitos">
                      Requisitos del curso
                    </label>
                  </div>

                  <div className="input-field">
                    <select name="forma_pago" onChange={leerDato} required>
                      {curso.data_pago.costo_mensual ? (
                        <option value="1" selected>
                          3 mensualidades
                        </option>
                      ) : (
                        <option value="1">3 mensualidades</option>
                      )}
                      {curso.data_pago.costo_mensual === undefined &&
                      curso.data_pago.costo_sabatino === undefined ? (
                        <option value="2" selected>
                          Pago de contado
                        </option>
                      ) : (
                        <option value="2">Pago de contado</option>
                      )}
                      {curso.data_pago.costo_sabatino ? (
                        <option value="3" selected>
                          Precio con descuento
                        </option>
                      ) : (
                        <option value="3">Precio con descuento</option>
                      )}
                    </select>
                    <label>Formas de pago</label>
                  </div>
                  <div>
                    {curso.data_pago.costo_mensual && (
                      <div>
                        <div className="input-field">
                          <input
                            onChange={leerPago}
                            defaultValue={curso.data_pago.costo_total}
                            id="costo_total"
                            name="costo_total"
                            type="text"
                            className="validate"
                            required
                          />
                          <label className="active" for="costo_total">
                            Costo Total
                          </label>
                        </div>
                        <div className="input-field">
                          <input
                            onChange={leerPago}
                            defaultValue={curso.data_pago.costo_mensual}
                            id="costo_mensual"
                            name="costo_mensual"
                            type="text"
                            className="validate"
                            required
                          />
                          <label className="active" for="costo_mensual">
                            Mensualidades
                          </label>
                        </div>
                        <div className="input-field">
                          <input
                            onChange={leerPago}
                            defaultValue={curso.data_pago.costo_contado}
                            id="costo_contado"
                            name="costo_contado"
                            type="text"
                            className="validate"
                            required
                          />
                          <label className="active" for="costo_contado">
                            Pago de contado
                          </label>
                        </div>
                      </div>
                    )}
                    {curso.data_pago.costo_mensual === undefined &&
                      curso.data_pago.costo_sabatino === undefined && (
                        <div>
                          <div className="input-field">
                            <input
                              onChange={leerPago}
                              defaultValue={curso.data_pago.costo_total}
                              id="costo_total"
                              name="costo_total"
                              type="text"
                              className="validate"
                              required
                            />
                            <label className="active" for="costo_total">
                              Costo Total
                            </label>
                          </div>
                        </div>
                      )}
                    {curso.data_pago.costo_sabatino && (
                      <div>
                        <div className="input-field">
                          <input
                            onChange={leerPago}
                            defaultValue={curso.data_pago.costo_total}
                            id="costo_total"
                            name="costo_total"
                            type="text"
                            className="validate"
                            required
                          />
                          <label className="active" for="costo_total">
                            Costo Total
                          </label>
                        </div>
                        <div className="input-field">
                          <input
                            onChange={leerPago}
                            defaultValue={curso.data_pago.costo_sabatino}
                            id="costo_sabatino"
                            name="costo_sabatino"
                            type="text"
                            className="validate"
                            required
                          />
                          <label className="active" for="costo_sabatino">
                            Costo Sabatino
                          </label>
                        </div>
                      </div>
                    )}
                  </div>

                  {!flag ? (
                    <p>Cargando etiquetas...</p>
                  ) : (
                    <div className="input-field">
                      <select name="etiquetas" onChange={leerOpciones} multiple>
                        {curso.etiquetas
                          ? etiquetas.map((etiqueta) =>
                              curso.etiquetas.includes(etiqueta._id) ? (
                                <option value={etiqueta._id} selected>
                                  {etiqueta.nombre}
                                </option>
                              ) : (
                                <option value={etiqueta._id}>
                                  {etiqueta.nombre}
                                </option>
                              )
                            )
                          : etiquetas.map((etiqueta) => (
                              <option value={etiqueta._id}>
                                {etiqueta.nombre}
                              </option>
                            ))}
                      </select>
                      <label>Etiquetas</label>
                    </div>
                  )}

                  {!flagFechas ? (
                    <div>
                      <Loader />
                    </div>
                  ) : (
                    <div>
                      <div>
                        <p>Próximas fechas</p>
                        <div
                          className="boton_agregar_formulario"
                          onClick={agregarFecha}
                        >
                          <img src={icon1} alt="" style={{ width: "23px" }} />
                        </div>
                      </div>
                      {curso.fechas.map((fecha, index) => (
                        <div>
                          <div>
                            <p style={{ fontWeight: "bold" }}>
                              Fecha {index + 1}
                            </p>
                            <div
                              onClick={(e) => {
                                eliminarFecha(e, index);
                              }}
                              style={{
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={icon63}
                                alt=""
                                style={{ width: "100%" }}
                              />
                            </div>
                          </div>
                          <div className="input-field">
                            <input
                              defaultValue={curso.fechas[index].dias}
                              onChange={(e) => {
                                leerFecha(e, index);
                              }}
                              id={"dias_" + index}
                              name="dias"
                              type="text"
                              className="validate"
                              required
                            />
                            <label
                              className={
                                curso.fechas[index].dias != "" && "active"
                              }
                              for={"dias_" + index}
                            >
                              Días
                            </label>
                          </div>
                          <div className="input-field">
                            <input
                              defaultValue={curso.fechas[index].horario}
                              onChange={(e) => {
                                leerFecha(e, index);
                              }}
                              id={"horario_" + index}
                              name="horario"
                              type="text"
                              className="validate"
                              required
                            />
                            <label
                              className={
                                curso.fechas[index].dias != "" && "active"
                              }
                              for={"horario_" + index}
                            >
                              Horario
                            </label>
                          </div>
                          <div>
                            <p>Fecha: {}</p>
                            <input
                              type="text"
                              placeholder="Inicio"
                              name="fecha_inicio"
                              id={"fecha_" + index}
                              className="datepicker"
                              required
                            />
                            <input
                              type="text"
                              placeholder="Fin"
                              name="fecha_fin"
                              id={"fecha_" + index}
                              className="datepicker"
                              required
                            />
                          </div>
                          <div className="input-field">
                            <input
                              defaultValue={curso.fechas[index].sesiones}
                              onChange={(e) => {
                                leerFecha(e, index);
                              }}
                              id={"sesiones_" + index}
                              name="sesiones"
                              type="text"
                              className="validate"
                              required
                            />
                            <label
                              className={
                                curso.fechas[index].dias != "" && "active"
                              }
                              for={"sesiones_" + index}
                            >
                              Numero de sesiones
                            </label>
                          </div>
                          <div className="input-field">
                            <input
                              defaultValue={curso.fechas[index].duracion}
                              onChange={(e) => {
                                leerFecha(e, index);
                              }}
                              id={"duracion_" + index}
                              name="duracion"
                              type="text"
                              className="validate"
                              required
                            />
                            <label
                              className={
                                curso.fechas[index].dias != "" && "active"
                              }
                              for={"duracion_" + index}
                            >
                              Total de horas
                            </label>
                          </div>
                          {!flag ? (
                            <p>Cargando profesores...</p>
                          ) : (
                            <div className="input-field">
                              <select
                                name="tutor"
                                id={"tutor_" + index}
                                onChange={(e) => {
                                  leerFecha(e, index);
                                }}
                                required
                              >
                                <option value="0">
                                  Selecciona un profesor
                                </option>
                                {profesoresCursos.map((profesor) =>
                                  profesor._id === curso.fechas[index].tutor ? (
                                    <option value={profesor._id} selected>
                                      {profesor.nombre}
                                    </option>
                                  ) : (
                                    <option value={profesor._id}>
                                      {profesor.nombre}
                                    </option>
                                  )
                                )}
                              </select>
                              <label>Profesores</label>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* aqui hay imagen */}
                  <p>Carrusel de 6 imagenes</p>
                  <div
                    style={{
                      position: "relative",
                      overflow: "auto",
                      display: "flex",
                      width: "323px",
                    }}
                  >
                    {curso.carrusel_imagenes.map((imagen) => (
                      <img
                        alt="imagen subida"
                        style={{ width: "100%", height: "100%" }}
                        src={imagen}
                      ></img>
                    ))}
                  </div>
                  <div className="file-field input-field">
                    <div className="btn">
                      <span>File</span>
                      <input
                        name="carrusel_imagenes"
                        onChange={actualizarCarrusel}
                        type="file"
                        multiple
                      />
                    </div>
                    <div className="file-path-wrapper">
                      <input
                        name="carrusel_imagenes"
                        className="file-path validate"
                        type="text"
                        placeholder="Upload one or more files"
                      />
                    </div>
                  </div>

                  <p>¿Tiene video de YouTube?</p>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <p>
                      <label>
                        <input
                          onClick={() => {
                            setYoutubePregunta(false);
                          }}
                          name="youtubePregunta"
                          type="radio"
                          checked
                        />
                        <span>No</span>
                      </label>
                    </p>
                    <p>
                      <label>
                        <input
                          onClick={() => {
                            setYoutubePregunta(true);
                          }}
                          name="youtubePregunta"
                          type="radio"
                        />
                        <span>si</span>
                      </label>
                    </p>
                  </div>
                  {youtubePregunta && (
                    <div>
                      <iframe
                        style={{ width: "100%", height: "auto" }}
                        src={curso.url_youtube}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                      <div className="input-field">
                        <input
                          onChange={leerYoutube}
                          defaultValue={curso.url_youtube}
                          id="url_youtube"
                          name="url_youtube"
                          type="text"
                          className="validate"
                        />
                        <label className="active" for="url_youtube">
                          URL Youtube
                        </label>
                      </div>
                    </div>
                  )}

                  <p>Imagen Individual</p>
                  <img
                    alt="imagen subida"
                    style={{ width: "320px" }}
                    src={curso.imagen_indvidual}
                  ></img>
                  <div className="file-field input-field">
                    <div className="btn">
                      <span>File</span>
                      <input
                        name="imagen_indvidual"
                        onChange={actualizarFoto}
                        type="file"
                      />
                    </div>
                    <div className="file-path-wrapper">
                      <input
                        name="imagen_indvidual"
                        className="file-path validate"
                        type="text"
                        placeholder="Upload one or more files"
                      />
                    </div>
                  </div>

                  <p>Gratis para alumnos activos</p>
                  <div>
                    <p>
                      <label>
                        {curso.gratis ? (
                          <input
                            name="gratis"
                            type="radio"
                            checked
                            onChange={() => {
                              setCurso({
                                ...curso,
                                gratis: true,
                                descuento_alumno: false,
                              });
                            }}
                          />
                        ) : (
                          <input
                            name="gratis"
                            type="radio"
                            onChange={() => {
                              setCurso({
                                ...curso,
                                gratis: true,
                                descuento_alumno: false,
                              });
                            }}
                          />
                        )}
                        <span>Si</span>
                      </label>
                    </p>
                    <p>
                      <label>
                        {!curso.gratis ? (
                          <input
                            name="gratis"
                            type="radio"
                            checked
                            onChange={() => {
                              setCurso({
                                ...curso,
                                gratis: false,
                                descuento_alumno: false,
                              });
                            }}
                          />
                        ) : (
                          <input
                            name="gratis"
                            type="radio"
                            onChange={() => {
                              setCurso({
                                ...curso,
                                gratis: false,
                                descuento_alumno: false,
                              });
                            }}
                          />
                        )}
                        <span>No</span>
                      </label>
                    </p>
                    <p>
                      <label>
                        {curso.descuento_alumno ? (
                          <input
                            name="gratis"
                            type="radio"
                            checked
                            onChange={() => {
                              setCurso({
                                ...curso,
                                descuento_alumno: true,
                                gratis: false,
                              });
                            }}
                          />
                        ) : (
                          <input
                            name="gratis"
                            type="radio"
                            onChange={() => {
                              setCurso({
                                ...curso,
                                descuento_alumno: true,
                                gratis: false,
                              });
                            }}
                          />
                        )}
                        <span>Descuento</span>
                      </label>
                    </p>
                    {curso.descuento_alumno && (
                      <div className="input-field">
                        <input
                          defaultValue={curso.cantidad_descuento_alumno}
                          onChange={leerDato}
                          id="cantidad_descuento_alumno"
                          name="cantidad_descuento_alumno"
                          type="text"
                          className="validate"
                          required
                        />
                        <label
                          className={curso.descuento_alumno != "" && "active"}
                          for="cantidad_descuento_alumno"
                        >
                          Precio del descuento de alumnos
                        </label>
                      </div>
                    )}
                  </div>
                </Fragment>
              ) : (
                <OfertaRelampago profesoresCursos={profesoresCursos} />
              )}

              <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
                <button type="submit">Actualizar curso</button>
              </div>
            </form>
          )}
          <div className="botonn_2_admin" style={{ marginTop: "10px" }}>
            <button onClick={eliminarArchivosRecursivo}>Eliminar curso</button>
          </div>
        </FormularioEditar>
      </div>
      <div className="row">
        <div
          id="vistas_generales"
          className="col s12 vistas_generales_cursos"
          style={{ padding: "0", display: "flex", justifyContent: "center" }}
        >
          <div className="container border">
            <div></div>
          </div>
          <div className="container componente_editable_padre">
            {!flagActualizar ? (
              <div>
                <Loader />
              </div>
            ) : (
              <Fragment>
                <div style={{ margin: "100px 0" }} className="flex_padre_2_d3">
                  <Etiqueta curso={curso} />
                </div>
                <img
                  id="imagen_estatica"
                  src={curso.imagen_interna}
                  alt={curso.nombre}
                  style={{
                    width: "100%",
                  }}
                />
                <div className="row">
                  <div className="col s12 m12 l8 xl8">
                    <p
                      className="titulo_1_nv"
                      style={{
                        color: "#AE4DEB",
                        marginBottom: "10px",
                        marginBottom: "-15px",
                      }}
                    >
                      {curso.nombre}
                    </p>
                    <div
                      className="informacion_curso"
                      dangerouslySetInnerHTML={createMarkup(descripcionCurso)}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "25px",
                        margin: "30px 0",
                      }}
                    >
                      <img
                        style={{ width: "75px", borderRadius: "50%" }}
                        src={obtenerProfesor(curso.fechas[0].tutor).imagen}
                        alt="profesor"
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <p className="etiqueta">
                            {obtenerProfesor(curso.fechas[0].tutor).nombre}
                          </p>
                          <p className="etiqueta_fin">.</p>
                        </div>
                        <p style={{ margin: "0" }}>
                          {obtenerProfesor(curso.fechas[0].tutor).certificado}
                        </p>
                      </div>
                    </div>
                    <div>
                      <img
                        src={curso.carrusel_imagenes[carrusel]}
                        alt={curso.nombre}
                        style={{ width: "100%" }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {curso.carrusel_imagenes.map((imagen, index) => (
                          <div style={{ width: "15.5%" }}>
                            <img
                              src={imagen}
                              alt={curso.nombre}
                              onClick={() => {
                                setCarrusel(index);
                              }}
                              style={{ width: "100%" }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                    <div
                      className="informacion_curso"
                      dangerouslySetInnerHTML={createMarkup(descripcionInterna)}
                    />
                    <div className="contenedor_video">
                      <iframe
                        className="video"
                        src={curso.url_youtube}
                        title={curso.nombre}
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                    </div>
                    <ul className="collapsible collapsible_curso">
                      <li
                        className="active"
                        style={{ background: "#AE4DEB", borderRadius: "20px" }}
                      >
                        <div className="collapsible-header collapsible-header_curso">
                          Contenido del curso
                        </div>
                        <div
                          className="collapsible-body collapsible-body_curso"
                          dangerouslySetInnerHTML={createMarkup(contenido)}
                        ></div>
                      </li>
                    </ul>
                    <p
                      className="encabezadosMonserrat"
                      style={{ fontWeight: "bold", color: "#AE4DEB" }}
                    >
                      Próximas fechas
                    </p>
                    {fechas.map((fecha, index) => (
                      <div style={{ marginBottom: "25px" }}>
                        <p
                          className="titulo_2_nv"
                          style={{ margin: "0px", color: "#AE4DEB" }}
                        >
                          Fecha {index + 1}:
                        </p>
                        <p style={{ fontWeight: "bold", margin: "0px" }}>
                          Del{" "}
                          {new Date(curso.fechas[index].fecha_inicio).getDate()}{" "}
                          de{" "}
                          {
                            meses[
                              new Date(
                                curso.fechas[index].fecha_inicio
                              ).getMonth()
                            ]
                          }{" "}
                          al {new Date(curso.fechas[index].fecha_fin).getDate()}{" "}
                          de{" "}
                          {
                            meses[
                              new Date(curso.fechas[index].fecha_fin).getMonth()
                            ]
                          }{" "}
                          de{" "}
                          {new Date(
                            curso.fechas[index].fecha_fin
                          ).getFullYear()}
                        </p>
                        <p style={{ margin: "0px" }}>
                          <b>Días:</b> {fecha.dias}
                        </p>
                        <p style={{ margin: "0px" }}>
                          <b>Horario:</b> {fecha.horario} horas
                        </p>
                        <p style={{ margin: "0px" }}>
                          <b>Número de sesiones:</b> {fecha.sesiones}
                        </p>
                        <p style={{ margin: "0px" }}>
                          <b>Total de horas:</b> {fecha.duracion}
                        </p>
                        <p style={{ margin: "0px" }}>
                          <b>Docente:</b> {obtenerProfesor(fecha.tutor).nombre}
                        </p>
                      </div>
                    ))}
                    <div className="inversiones">
                      <p
                        className="encabezadosMonserrat"
                        style={{ fontWeight: "bold", marginBottom: "15px" }}
                      >
                        Inversión
                      </p>
                      {curso.data_pago.costo_total &&
                        !curso.data_pago.costo_contado && (
                          <p
                            className="encabezadosMonserrat"
                            style={{ fontWeight: "bold" }}
                          >
                            ${curso.data_pago.costo_total} MXN
                          </p>
                        )}
                      {curso.data_pago.costo_contado && (
                        <p
                          className="encabezadosMonserrat"
                          style={{ fontWeight: "bold" }}
                        >
                          ${curso.data_pago.costo_contado} MXN de contado
                        </p>
                      )}
                      {curso.data_pago.costo_mensual && (
                        <p>
                          3 mensualidades de: ${curso.data_pago.costo_mensual}{" "}
                          MXN
                        </p>
                      )}
                      {curso.gratis && (
                        <p style={{ fontWeight: "bold" }}>
                          Si eres estudiante de nuestras licenciaturas $ 000 MXN
                        </p>
                      )}
                      <p style={{ fontStyle: "italic" }}>
                        Precios sujetos a cambio sin previo aviso.
                      </p>
                    </div>
                    <img
                      src={curso.imagen_indvidual}
                      alt={curso.nombre}
                      style={{ width: "100%", marginBottom: "35px" }}
                    />
                    <div className="pagar_curso">
                      <p
                        className="encabezadosMonserrat"
                        style={{ fontWeight: "bold", marginBottom: "15px" }}
                      >
                        Cómo pagar
                      </p>
                      <p>1. Solicita tu ficha de inscripción</p>
                      <p>2. Haz tu pago:</p>
                      <p style={{ fontWeight: "bold" }}>
                        En persona, en la Caja General de la Sede Gance:
                      </p>
                      <p style={{ marginLeft: "35px" }}>• En efectivo</p>
                      <p style={{ marginLeft: "35px" }}>
                        • Con tarjeta de débito o crédito
                      </p>
                      <p style={{ marginLeft: "35px" }}>• Con cheque</p>
                      <p style={{ fontWeight: "bold" }}>
                        En ventanilla de Banorte o Banamex.
                      </p>
                      <p style={{ fontWeight: "bold" }}>
                        O desde la app de tu banco, por transferencia bancaria.
                      </p>
                      <p>
                        3. Envía tu ficha de inscripción llena y tu comprobante
                        de pago aquí para apartar tu lugar.
                      </p>
                      <p>
                        4. Recibirás un correo de bienvenida para confirmar tu
                        lugar.
                      </p>
                    </div>
                    <div className="inversiones">
                      <p
                        className="encabezadosMonserrat"
                        style={{ fontWeight: "bold", marginBottom: "15px" }}
                      >
                        Importante:
                      </p>
                      <p style={{ fontWeight: "bold" }}>
                        Todo curso, taller o diplomado puede suspenderse o
                        postergarse, en caso de que no reúna el quórum mínimo
                        necesario y te devolveremos tu dinero o puedes usarlo
                        para tomarlo cuando éste se abra, o a cuenta de otro
                        producto de nuestro catálogo.
                        <br />
                        <br />
                        Por otro lado, si decides no asistir o te das de baja,
                        no recibirás devolución de tu pago.
                      </p>
                    </div>
                  </div>
                  <div className="col s12 m12 l4 xl4">
                    <div id="curso_fixme" className="curso_fijo">
                      <div className="tarjeta_fixme">
                        <div className="seccion_curso_fixme">
                          <p
                            className="encabezadosMonserrat"
                            style={{
                              fontWeight: "bold",
                              color: "#AE4DEB",
                              marginBottom: "1px",
                            }}
                          >
                            ${curso.data_pago.costo_total} MXN
                          </p>
                          {curso.data_pago.costo_mensual && (
                            <p style={{ margin: "0px", color: "#464646" }}>
                              3 mensualidades de: $
                              {curso.data_pago.costo_mensual} MXN
                            </p>
                          )}
                          {curso.gratis && (
                            <p
                              style={{
                                fontWeight: "bold",
                                color: "#8A6AAC",
                                marginTop: "1px",
                              }}
                            >
                              Si eres estudiante de nuestras licenciaturas $ 000
                              MXN
                              <button
                                style={{
                                  color: "#00B5C1",
                                  border: "none",
                                  background: "transparent",
                                  fontWeight: "bold",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                Ver condiciones
                              </button>
                            </p>
                          )}
                        </div>
                        <div className="divider" />
                        <div className="seccion_curso_fixme">
                          <div style={{ margin: "0 0 15px 35px" }}>
                            <p
                              style={{
                                margin: "0px",
                                fontWeight: "bold",
                                color: "#464646",
                              }}
                            >
                              Nivel
                            </p>
                            <div className="icono_texto">
                              <img src={img_nivel} alt="nivel del curso" />
                              <p style={{ margin: "0px", color: "#5ABF3F" }}>
                                {nivel[curso.nivel]}
                              </p>
                            </div>
                          </div>
                          <div style={{ margin: "0 0 15px 35px" }}>
                            <p
                              style={{
                                margin: "0px",
                                fontWeight: "bold",
                                color: "#464646",
                              }}
                            >
                              Formato
                            </p>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {curso.formato.map((formato_numero, index) => (
                                <div className="icono_texto">
                                  <img
                                    src={formato_img[formato_numero]}
                                    alt="formato del curso"
                                  />
                                  <p
                                    style={{
                                      margin: "0 5px 0 0",
                                      color: "#F49A3F",
                                    }}
                                  >
                                    {formato[formato_numero]}{" "}
                                    {index < curso.formato.length - 1 && ","}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div style={{ margin: "0 0 15px 35px" }}>
                            <p
                              style={{
                                margin: "0px",
                                fontWeight: "bold",
                                color: "#464646",
                              }}
                            >
                              Modalidad
                            </p>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {curso.modalidad.map((modaidad_numero, index) => (
                                <div className="icono_texto">
                                  <img
                                    src={modalidad_img[modaidad_numero]}
                                    alt="modalidad del curso"
                                  />
                                  <p
                                    style={{
                                      margin: "0 5px 0 0",
                                      color: "#64C5DD",
                                    }}
                                  >
                                    {modailida[modaidad_numero]}{" "}
                                    {index < curso.modalidad.length - 1 && ","}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div style={{ margin: "0 0 15px 35px" }}>
                            <div className="icono_texto">
                              <img
                                src={img_requieres}
                                alt="formato del curso"
                              />
                              <p
                                style={{
                                  margin: "0px",
                                  fontWeight: "bold",
                                  color: "#F9007A",
                                }}
                              >
                                Requieres
                              </p>
                            </div>
                            <p style={{ margin: "0px", color: "#464646" }}>
                              {curso.requisitos}
                            </p>
                          </div>
                          <div>
                            <p
                              style={{
                                margin: "0px",
                                fontWeight: "bold",
                                color: "#464646",
                              }}
                            >
                              Relacionados con tu búsqueda:
                            </p>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {etiquetas.map((etiqueta) => (
                                <div style={{ display: "flex" }}>
                                  <p className="etiqueta">{etiqueta.nombre}</p>
                                  <p className="etiqueta_fin">.</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="divider" />
                        <div
                          className="seccion_curso_fixme"
                          style={{ marginTop: "15px" }}
                        >
                          <a className="boton_curso" href="#">
                            <img src={img_whats} alt="WhatsApp" />
                            <p style={{ margin: "0px" }}>
                              ¡Quiero inscribirme!
                            </p>
                          </a>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <img
                              src={img_warning}
                              alt="Apertura sujeta a un quórum mínimo"
                            />
                            <p
                              style={{
                                color: "#A80B38",
                                fontWeight: "bold",
                                fontSize: "13px",
                              }}
                            >
                              Apertura sujeta a un quórum mínimo
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="tarjeta_fixme"
                        style={{ background: "#F5F5F5", marginTop: "30px" }}
                      >
                        <div className="seccion_curso_fixme">
                          <p
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              color: "#00476F",
                              textAlign: "center",
                            }}
                          >
                            ¿Te interesa este curso para un equipo?
                          </p>
                          <a className="boton_curso" href="#">
                            <p style={{ margin: "0px" }}>Hablemos</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
          <div
            onClick={() => {
              actualizarCurso();
            }}
            className="container efecto_blur"
          ></div>
        </div>
      </div>
    </Fragment>
  );
};

export default Curso;
